<div class="ui-g-12 footer">
    <div class="ui-g-2">
        <span translate>COMMON.VERSIONCHAR</span>
        <span translate>APP.VERSION</span>
    </div>
    <div class="ui-g-8" style="text-align: center;">
        &copy;&nbsp;<span translate>APP.COPYRIGHTYEAR</span>
        &nbsp;<span translate>COMMON.KEYSTONEKUBB</span>
    </div>
</div>